// extracted by mini-css-extract-plugin
export default {"icon-button":"icon-button__3yVo8"};